// extracted by mini-css-extract-plugin
module.exports =  {"footerBanner":"FooterOverlay-module_footerBanner_df17a","showFooter":"FooterOverlay-module_showFooter_ff1d5"};